import React from 'react';
import PropTypes from 'prop-types';
import { currencyFormatter } from 'utils/formatter';
import styles from './RewardRedemption.css';

class RewardRedemption extends React.Component {
  render() {
    const { redeemReward, redeemAmount } = this.props;
    return (
      Boolean(redeemReward) && (
        <div className="row discount-row border-on-bottom">
          <div className="col-md-12">
            <label>Redeemed Reward</label>
            <table className="table mk-table-summary table-truncate">
              <tbody>
                <tr>
                  <td width="55%" className="name-item-refund tax-grat-disc">
                    {redeemReward}
                  </td>
                  <td
                    width="45%"
                    className={`text-right price text-gray no-border ${
                      styles['redeem-amount']
                    }`}
                  >
                    {Number.isFinite(-redeemAmount) &&
                      currencyFormatter(-redeemAmount)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )
    );
  }
}

RewardRedemption.propTypes = {
  redeemReward: PropTypes.string,
  redeemAmount: PropTypes.number,
};

export default RewardRedemption;
